import React from 'react';
import PropTypes from 'prop-types';
import './ConvertedContent.css'; // Importing the CSS. Assuming ConvertedContent.css is in the same folder

const ConvertedContent = ({
  font, fontSize, lineSpacing, convertedHTML,
}) => (
  <div className="converted-content-container" style={{ fontFamily: font, fontSize, lineHeight: lineSpacing }}>
    <div className="converted-content" dangerouslySetInnerHTML={{ __html: convertedHTML }} />
  </div>
);

// Prop type validation
ConvertedContent.propTypes = {
  font: PropTypes.string.isRequired,
  fontSize: PropTypes.string.isRequired,
  lineSpacing: PropTypes.string.isRequired,
  convertedHTML: PropTypes.string.isRequired,
};

export default ConvertedContent;
